import React from "react";

const currentYear = new Date().getFullYear();

const PageFooter = () => (
  <div className="view-page__footer">
    © {currentYear} Koninklijke Brill NV. For more information please visit{" "}
    <a href="http://www.brill.com">
      www.brill.com
    </a> &middot; <a href="http://www.brill.com/about/policies/privacy-statement">
      Privacy Policy
    </a> &middot; <a href="http://www.brill.com/about/policies/rights-permissions">
      Copyright &amp; Permissions
    </a>
  </div>
);

export default PageFooter;
